import { getType, Reducer } from 'typesafe-actions'

import { withLoadingReducer } from '../loading'

import { CheckoutActions } from './actions'
import { CheckoutState } from './types'

export const initialState: CheckoutState = {
  error: undefined,
  customerRequestIds: [],
  order: {
    orderMetadata: undefined,
    orderItems: []
  }
}

export const reducer: Reducer<CheckoutState, CheckoutActions> = (state = initialState, action) => {
  switch (action.type) {
    case getType(CheckoutActions.setCheckoutOrderData):
      return {
        ...state,
        order: {
          ...state.order,
          orderData: action.payload.order
        }
      }
    case getType(CheckoutActions.setCheckoutOrderItems): {
      return {
        ...state,
        order: {
          ...state.order,
          orderItems: action.payload.items
        }
      }
    }
    case getType(CheckoutActions.orderPlaced): {
      return {
        ...state,
        customerRequestIds: action.payload.customerRequestIds
      }
    }
    case getType(CheckoutActions.orderFailed): {
      return {
        ...state,
        error: action.payload.error
      }
    }
    case getType(CheckoutActions.setCountries): {
      return {
        ...state,
        countries: action.payload.countries
      }
    }
    case getType(CheckoutActions.setStates): {
      return {
        ...state,
        states: action.payload.states
      }
    }
    case getType(CheckoutActions.setPaymentOptions): {
      return {
        ...state,
        paymentOptions: action.payload.paymentOptions
      }
    }
    default:
      return state
  }
}

export const checkoutReducer = withLoadingReducer(reducer, 'checkout', initialState)
